var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('QS-h4-title',{attrs:{"title":"开票信息"}}),_vm._v(" "),_c('QS-column-box',{attrs:{"column":3,"source":_vm.data,"labelWidth":"150","separator":":","list":_setup.invoicing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }